const schema = (feeType) => ({
  type: 'object',
  required: [],
  properties: {
    title: {
      type: 'string',
      title: 'عنوان غرفه',
    },
    user_id: {
      type: 'string',
      title: 'مالک',
    },
    shop_id: {
      type: 'string',
      title: 'فروشگاه',
    },
    fee_type_id: {
      type: 'string',
      title: 'نوع کارمزد',
      oneOf: feeType,
    },
    fee_ceiling: {
      type: 'number',
      title: 'سقف کارمزد',
    },
    code: {
      type: 'string',
      title: 'کد غرفه',
    },
    is_active: {
      type: 'number',
      title: 'فعالیت',
      oneOf: [
        { const: 1, title: 'فعال' },
        { const: 0, title: 'غیرفعال' },
      ],
    },
  },
  allOf: [
    {
      if: {
        properties: {
          fee_type_id: {
            const: '1',
          },
        },
      },
      then: {
        properties: {
          fee_value: {
            type: 'number',
            title: 'مقدار کارمزد (درصد)',
            minimum: 0,
            maximum: 100,
          },
        },
      },
    },
    {
      if: {
        properties: {
          fee_type_id: {
            const: '2',
          },
        },
      },
      then: {
        properties: {
          fee_value: {
            type: 'number',
            title: 'مقدار کارمزد (تومان)',
            minimum: 0,
          },
        },
      },
    },
  ],
});

export default schema;
